import { createContext, useContext, useEffect, useRef } from 'react';
import invariant from 'invariant';
import { incaAccessor } from '@cancercentrum/inca';
export const ErrandPanelApiContext = /*#__PURE__*/ createContext(null);
export const useErrandPanelApiContext = ()=>{
    return useContext(ErrandPanelApiContext);
};
export const useErrandPanelApi = ()=>{
    const ctx = useErrandPanelApiContext();
    const inca = incaAccessor();
    const isErrand = !!inca.form.data.errandId;
    invariant(!isErrand || inca.form.useSimplifiedErrandType, 'useErrandPanelApi requires useSimplifiedErrandType to be true');
    return ctx;
};
export function useErrandPanelEventHandler(eventName, handler, options) {
    const errandPanelApi = useErrandPanelApi();
    const hRef = useRef(handler);
    hRef.current = handler;
    const optsRef = useRef(options);
    optsRef.current = options;
    useEffect(()=>{
        if (!errandPanelApi) {
            return;
        }
        const delegator = (...args)=>{
            return hRef.current(...args);
        };
        const registator = errandPanelApi.events[eventName];
        registator.on(delegator, optsRef.current);
        return ()=>{
            registator.off(delegator);
        };
    }, [
        eventName,
        errandPanelApi
    ]);
}
export const useOnBeforeExecuteErrand = (fn, options)=>{
    useErrandPanelEventHandler('onBeforeExecuteErrand', fn, options);
};
export const useOnAfterExecuteErrand = (fn, options)=>{
    useErrandPanelEventHandler('onAfterExecuteErrand', fn, options);
};
export const useOnEvaluateButtonState = (fn, options)=>{
    useErrandPanelEventHandler('onEvaluateButtonState', fn, options);
};
